module.exports = __webpack_public_path__ + "img/image21.5afdad55.jpg";